import { v5 as uuidv5 } from "uuid"

const ID = "0b8fde26-5512-4e92-92bb-270bf1b8e274"

export function uuid(key) {
  return uuidv5(key, ID)
}
